import { useCallback, useState } from "react";

type IOptions<T> = {
  initialValue?: T;
  value?: T;
  setValue?: (value: T) => void;
};

export function useControllableState<T>({
  initialValue,
  value,
  setValue,
}: IOptions<T>) {
  const [uncontrolledValue, setUncontrolledValue] = useState(initialValue as T);

  const _value = value !== undefined ? value : uncontrolledValue;
  const _setValue = useCallback(
    (value: T) => {
      setValue?.(value);
      setUncontrolledValue(value);
    },
    [setValue, setUncontrolledValue]
  );

  return [_value, _setValue] as const;
}
